export enum PAYMENT_TERM {
  CASH = 'ZCON',
  CONCRETE_CASH = 'ZCOC',
}

export enum PaymentTermDesc {
  CASH = 'CASH',
  CREDIT = 'CREDIT',
}

export const paymentTermCodeToDescMap = new Map([
  [PAYMENT_TERM.CASH, PaymentTermDesc.CASH],
  [PAYMENT_TERM.CONCRETE_CASH, PaymentTermDesc.CASH],
]);

export function getPaymentTermDescFromCode(code) {
  return paymentTermCodeToDescMap.get(code) || PaymentTermDesc.CREDIT;
}
